import React from 'react';

const Footer = () => {
  return (
    <>
      <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
      <footer 
        className="footer" 
        style={{
          position: 'fixed',
          bottom: 0,
          width: '100%',
          textAlign: 'right',
          opacity: 0.4,
          padding: '10px 20px'
        }}
      >
        2019 - {new Date().getFullYear()} &copy; PCP Express - www.pcpexpress.com
      </footer>
    </>
  );
};

export default Footer;